module.exports = __webpack_public_path__ + "static/img/third.a55c565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tstj/third.png
// module id = bXte
// module chunks = 1